import { useEffect, useRef, useState } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";

const animatedComponents = makeAnimated();

export default function AnimatedSelect({
  options,
  value,
  topLeftLabel,
  onOptionChange,
  placeHolder,
  valueName,
  Name,
  isLoading,
  isDisabled,
  topLabel,
  isRequired,
  clearAble,
  isMulti = false,
}: any) {
  const [isWide, setIsWide] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        setIsWide(entry?.contentRect?.width < 275);
      }
    });

    if (ref?.current) {
      resizeObserver?.observe(ref?.current);
    }

    return () => {
      if (ref?.current) {
        resizeObserver?.unobserve(ref?.current);
      }
    };
  }, []);

  const customStyles = {
    control: (provided: any, state: any) => ({
      ...provided,
      borderRadius: "8px",
      minHeight: "43px",
      maxHeight: "50px",
      overflowY: "auto",
    }),
    multiValue: (provided: any, state: any) => ({
      ...provided,
      borderRadius: "10px",
      color: "#000",
    }),
    multiValueLabel: (provided: any, state: any) => ({
      ...provided,
      color: "#000",
    }),
    multiValueRemove: (provided: any, state: any) => ({
      ...provided,
      borderRadius: "0px 10px 10px 5px",
      color: "#000",
      "&:hover": {
        backgroundColor: "#ffb7b7",
        color: "#000",
      },
    }),
  };

  const reformedOptions = options
    ? options.map((group: any) => ({
        value: group[valueName],
        label: group[Name],
        color: group.is_active,
      }))
    : [];

  const truncateText = (text: string, length: any, indicator = "...") => {
    if (!text || text?.length <= length) return text;
    return text?.substring(0, length) + indicator;
  };

  return (
    <div
      ref={ref}
      className="flex w-full flex-col items-start justify-center gap-1"
    >
      <div className="flex w-full items-start justify-between">
        {topLabel && (
          <p className=" text-right text-gray-900 text-Body-OneLine/14/Regular">
            {topLabel}
            {isRequired && <span className="text-red-500">*</span>}
          </p>
        )}
        {topLeftLabel && topLeftLabel}
      </div>
      <div className="h-10 w-full">
        <Select
          noOptionsMessage={({ inputValue }) =>
            !inputValue ? "یافت نشد." : "یافت نشد."
          }
          isClearable={clearAble}
          isLoading={isLoading}
          isDisabled={isDisabled}
          placeholder={isWide ? truncateText(placeHolder, 10) : placeHolder}
          components={animatedComponents}
          options={reformedOptions}
          onChange={onOptionChange}
          styles={customStyles}
          value={value}
          className="basic-single"
          classNamePrefix="select"
          isMulti={isMulti}
        />
      </div>
    </div>
  );
}
